import { render } from "./OneTestDriverComponent.vue?vue&type=template&id=1e4a3d64&scoped=true"
import script from "./OneTestDriverComponent.vue?vue&type=script&lang=js"
export * from "./OneTestDriverComponent.vue?vue&type=script&lang=js"

import "./OneTestDriverComponent.vue?vue&type=style&index=0&id=1e4a3d64&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anupashyam\\Downloads\\gitlabs - rel path oops\\virtuallab-oop\\exp-10\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e4a3d64"]])

export default __exports__